import React from "react";

const Footer = () => {
  return (
    <div className="container">
      <div className="row">
        <p className="text-center">
          &copy; Shangilia Wholesaler Ltd. Designed by{" "}
          <a
            href="https://www.github.com/wamae-ndiritu"
            target="_blank"
            className="developer-link"
            rel="noreferrer"
          >
            Wamae
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
